<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
            >商品管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{
              path: `/commondityIndex/cManageEdit/cShopAttachment`,
            }"
            >商品配件</el-breadcrumb-item
          >
          <el-breadcrumb-item>商品配件设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>属性标签&变量规格式设置</h1>
        <div class="content_wrap">
          <div class="form_wrap">
            <div class="block" v-if="false">
              <p>属性标签缩略图</p>
              <div
                class="upload_box"
                @mouseenter="creenIndex = 1"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formData.pic">
                    <img :src="formData.pic" class="avatar" />
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span @click.stop="handlePictureCardPreview(formData.pic)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formData.pic = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>请输入配件商品的SKU编码</p>
              <div class="input_box">
                <el-input
                  v-model="formData.cmsku"
                  placeholder="请设置配件商品SKU"
                  :readonly="formData.id && formData.id != ''"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>每件配套数量</p>
              <div class="input_box">
                <el-input
                  v-model="formData.num"
                  placeholder="请设置每件配套数量"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>是否额外收费？</p>
              <div class="radio_box">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.isaddprice"
                  style="justify-content: space-evenly"
                  @change="handlePriceType"
                >
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否 </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="block" v-if="formData.isaddprice != ''">
              <p><span class="mark">*</span>额外收费价格</p>
              <div class="input_box">
                <el-input
                  v-model="formData.price"
                  placeholder="请设置价格"
                  type="digit"
                  @input="handleInputPrice"
                  :readonly="formData.isaddprice == 0"
                ></el-input>
              </div>
            </div>
            <div class="block">
              <p><span class="mark">*</span>是否启用</p>
              <div class="radio_box">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.isuse"
                  style="justify-content: space-evenly"
                >
                  <el-radio label="1">启用</el-radio>
                  <el-radio label="0">停用</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadImage } from "../../../api/api";
import {
  getShopAttachmentDetail,
  addShopAttachmentl,
  editShopAttachmentl,
} from "../../../api/shop";
export default {
  name: "cShopAttachmentSet",
  data() {
    return {
      loading: false,
      attrList: [], // 属性列表

      id: "", // 属性id
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "", // 商品id
        cmsku: "", // 配件商品SKU
        num: "", // 每件配套数量
        isaddprice: "", // 是否增加价格 =1=是 0=否
        price: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        pei_qyguid: "",
      },
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { cmId, id, cmSku } = this.$route.query;
    this.formData.cmid = cmId;
    console.log(cmSku, "===");
    // this.formData.cmsku = cmSku;
    this.formData.pei_qyguid = this.$store.state.USERINFO.qy
      ? this.$store.state.USERINFO.qy.qyguid
      : "";
    this.id = id;
    if (id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.loading = true;
      let { id } = this.$route.query;
      getShopAttachmentDetail({ id }).then((res) => {
        this.formData.id = res.id;
        this.formData.cmsku = res.cmsku;
        this.formData.num = res.num;
        this.formData.isaddprice = res.isaddprice;
        this.formData.price = res.price;
        this.formData.isuse = res.isuse;

        this.loading = false;
      });
    },

    handleReturn() {
      history.back();
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.formData.pic = res.url;
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handlePriceType(e) {
      if (e == 0) {
        this.formData.price = 0;
      } else {
        this.formData.price = "";
      }
    },

    query() {
      let { formData, id } = this;
      console.log(formData, "=--==--formData");
      let params = formData;
      if (formData.cmid == "") {
        this.$message.warning("请填写配件商品SKU");
        return false;
      }
      if (formData.num == "") {
        this.$message.warning("请填写每件配套数量");
        return false;
      }
      if (formData.isaddprice == "") {
        this.$message.warning("请选择是否增加价格");
        return false;
      }
      if (formData.price === "") {
        this.$message.warning("请填写价格");
        return false;
      }
      if (formData.isuse == "") {
        this.$message.warning("请选择是否启用");
        return false;
      }

      this.loading = true;
      if (id) {
        params.id = id;
        editShopAttachmentl(params).then((res) => {
          let data = res;
          if (data.result) {
            this.loading = false;
            this.$message.success(data.message);
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopAttachmentl(params).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(data.message);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            // this.$message.error(data.message || "服务器报错，请稍后～");
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message: data.message || "服务器报错，请稍后～",
            });
          }
        });
      }
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "" && url) {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
    // 输入框限制
    handleInputPrice(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.price = value;
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
}
</style>